import { assertNotEmpty } from '@festina-life/core'
import { useMemo, useState } from 'react'
import {
  Group,
  Panel,
  Separator,
  useDefaultLayout,
} from 'react-resizable-panels'

import { useTemplateContext } from '../../../context/templateContext'
import { isTemplateField } from '../../../types/templateModel'
import { DetailsLayout } from '../../detailsLayout/DetailsLayout'
import { getSpecialCasedSubTemplatedFieldValue } from '../../specialCasedSubTemplatedViewers/helpers'
import type { SpecialCasedSubTemplatedValueSetup } from '../../specialCasedSubTemplatedViewers/types'
import { TemplateFieldsTable } from '../../templateFieldsTable/TemplateFieldsTable'
import { TemplateFieldsTableContextProvider } from '../../templateFieldsTable/templateFieldsTableContext'
import { TemplateFieldContent } from './TemplateFieldContent'

type Props = {
  data: SpecialCasedSubTemplatedValueSetup
}

export const SpecialCasedSubTemplatedFieldValueContent = ({ data }: Props) => {
  const { fieldValueForPath } = useTemplateContext()
  const [selectedSubFieldPath, setSelectedSubFieldPath] = useState('')
  const selectedSubField = useMemo(
    () => fieldValueForPath(selectedSubFieldPath, 'current'),
    [fieldValueForPath, selectedSubFieldPath],
  )
  const { defaultLayout, onLayoutChanged } = useDefaultLayout({
    groupId: 'specialCaseDetailsPanel',
    storage: localStorage,
  })

  assertNotEmpty(data.field.value)

  const variant = getSpecialCasedSubTemplatedFieldValue(data)
  assertNotEmpty(variant)

  return (
    <TemplateFieldsTableContextProvider
      value={{ isTableInsideDetailsPanel: true, selectedSubFieldPath }}
    >
      <Group
        id="specialCaseDetailsPanel"
        orientation="vertical"
        defaultLayout={defaultLayout}
        onLayoutChanged={onLayoutChanged}
      >
        <Panel id="selectedVariantPanel" minSize="30%">
          <div className="rounded-md size-full p-2 pr-12 overflow-y-auto">
            <TemplateFieldsTable
              level={0}
              parent={data.field}
              fields={variant.fields}
              isCollapsible={false}
              onSelect={setSelectedSubFieldPath}
            />
          </div>
        </Panel>
        {selectedSubField && isTemplateField(selectedSubField) && (
          <>
            <Separator
              id="resizeSpecialCaseSubFieldPanel"
              className="h-1.5 dark:bg-slate-700 bg-slate-300"
            />
            <Panel
              id="specialCaseSubFieldPanel"
              minSize="50%"
              className="py-2 h-full overflow-auto! min-h-0"
            >
              <DetailsLayout>
                <TemplateFieldContent field={selectedSubField} />
              </DetailsLayout>
            </Panel>
          </>
        )}
      </Group>
    </TemplateFieldsTableContextProvider>
  )
}
